// /* eslint-disable */
// 'use client';

// import {
//   Box, Flex, Table, Tbody, Td, Text, Th, Thead, Tr, useColorModeValue,
//   Button, Input, FormControl, FormLabel, useToast, IconButton,
//   Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton,
//   useDisclosure, InputGroup, InputLeftElement, Select
// } from '@chakra-ui/react';
// import { MdEdit, MdDelete, MdSearch } from 'react-icons/md';
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import Card from 'components/card/Card';

// export default function CityManagement() {
//   const [countries, setCountries] = useState([]); // Dropdown ke liye
//   const [states, setStates] = useState([]); // Filtered States ke liye
//   const [cities, setCities] = useState([]); // All Cities list
//   const [searchTerm, setSearchTerm] = useState('');
//   const [loading, setLoading] = useState(false);

//   // Form States
//   const [selectedCountry, setSelectedCountry] = useState('');
//   const [selectedState, setSelectedState] = useState('');
//   const [cityName, setCityName] = useState('');
//   const [editData, setEditData] = useState({ id: '', name: '', stateId: '', countryId: '' });

//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const textColor = useColorModeValue('secondaryGray.900', 'white');
//   const toast = useToast();

//   const baseUrl = (process.env.REACT_APP_BASE_URL || '').replace(/\/?$/, '/');
//   const token = localStorage.getItem('token');

//   // 1. Initial Data Load (Countries & Cities)
//   const fetchData = async () => {
//     try {
//       const [countryRes, cityRes] = await Promise.all([
//         axios.get(`${baseUrl}api/country/getAll`, { headers: { Authorization: `Bearer ${token}` } }),
//         axios.get(`${baseUrl}api/city/getAll`, { headers: { Authorization: `Bearer ${token}` } })
//       ]);
//       setCountries(countryRes.data.countries || []);
//       setCities(cityRes.data.cities || []);
//     } catch (err) {
//       console.error("Fetch Error:", err);
//     }
//   };

//   useEffect(() => { fetchData(); }, []);

//   // 2. Dependency Logic: Jab Country change ho toh uske States fetch karo
//   const handleCountryChange = async (countryId) => {
//     setSelectedCountry(countryId);
//     setSelectedState(''); // Purana state clear karein
//     try {
//       const res = await axios.get(`${baseUrl}api/state/getByCountry/${countryId}`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       setStates(res.data.states || []);
//     } catch (err) {
//       setStates([]);
//     }
//   };

//   // 3. Add City
//   const handleAddCity = async () => {
//     if (!cityName || !selectedState) {
//       return toast({ title: 'Please select State and enter City name', status: 'warning' });
//     }
//     setLoading(true);
//     try {
//       await axios.post(`${baseUrl}api/city/add`, 
//         { name: cityName, stateId: selectedState }, 
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       toast({ title: 'City Added!', status: 'success' });
//       setCityName('');
//       fetchData();
//     } catch (err) { toast({ title: 'Error adding city', status: 'error' }); }
//     finally { setLoading(false); }
//   };

//   // 4. Update Logic
//   const openEditModal = (city) => {
//     setEditData({ 
//       id: city._id, 
//       name: city.name, 
//       stateId: city.stateId?._id,
//       countryId: city.stateId?.countryId // Backend se populated data chahiye
//     });
//     onOpen();
//   };

//   // 5. Filter for Table
//   const filteredCities = cities.filter((c) =>
//     c.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     c.stateId?.name?.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      
//       {/* ADD SECTION */}
//       <Card mb='20px' p='20px'>
//         <Text color={textColor} fontSize='22px' fontWeight='700' mb='20px'>City Management</Text>
//         <Flex gap='15px' align='flex-end' direction={{ base: 'column', md: 'row' }}>
//           <FormControl>
//             <FormLabel>Country</FormLabel>
//             <Select placeholder='Select Country' onChange={(e) => handleCountryChange(e.target.value)}>
//               {countries.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
//             </Select>
//           </FormControl>
//           <FormControl>
//             <FormLabel>State</FormLabel>
//             <Select placeholder='Select State' value={selectedState} onChange={(e) => setSelectedState(e.target.value)}>
//               {states.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
//             </Select>
//           </FormControl>
//           <FormControl>
//             <FormLabel>City Name</FormLabel>
//             <Input value={cityName} onChange={(e) => setCityName(e.target.value)} placeholder='Ex: Gwalior' />
//           </FormControl>
//           <Button colorScheme='blue' onClick={handleAddCity} isLoading={loading} px='40px'>Add</Button>
//         </Flex>
//       </Card>

//       {/* SEARCH & TABLE SECTION */}
//       <Card p='20px'>
//         <Flex justify='space-between' align='center' mb='20px'>
//           <Text color={textColor} fontSize='18px' fontWeight='700'>All Cities</Text>
//           <InputGroup maxW='300px'>
//             <InputLeftElement><MdSearch color='gray.300' /></InputLeftElement>
//             <Input placeholder='Search city...' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
//           </InputGroup>
//         </Flex>

//         <Box overflowX='auto'>
//           <Table variant='simple'>
//             <Thead bg='gray.50'>
//               <Tr>
//                 <Th>S.No</Th>
//                 <Th>City Name</Th>
//                 <Th>State</Th>
//                 <Th>Country</Th>
//                 <Th>Action</Th>
//               </Tr>
//             </Thead>
//             <Tbody>
//               {filteredCities.map((c, i) => (
//                 <Tr key={c._id}>
//                   <Td>{i + 1}</Td>
//                   <Td fontWeight='600'>{c.name}</Td>
//                   <Td>{c.stateId?.name || 'N/A'}</Td>
//                   <Td>{c.stateId?.countryId?.name || 'N/A'}</Td>
//                   <Td>
//                     <IconButton icon={<MdEdit />} colorScheme='green' onClick={() => openEditModal(c)} mr='2' />
//                     <IconButton icon={<MdDelete />} colorScheme='red' />
//                   </Td>
//                 </Tr>
//               ))}
//             </Tbody>
//           </Table>
//         </Box>
//       </Card>

//       {/* UPDATE MODAL (Similar to State modal but with State dropdown) */}
//       <Modal isOpen={isOpen} onClose={onClose}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>Update City</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <FormControl mb='4'>
//               <FormLabel>City Name</FormLabel>
//               <Input value={editData.name} onChange={(e) => setEditData({...editData, name: e.target.value})} />
//             </FormControl>
//           </ModalBody>
//           <ModalFooter>
//             <Button colorScheme='blue' onClick={() => {/* Update Function */}}>Save</Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>

//     </Box>
//   );
// }
/* eslint-disable */
// 'use client';

// import {
//   Box, Flex, Table, Tbody, Td, Text, Th, Thead, Tr, useColorModeValue,
//   Button, Input, FormControl, FormLabel, useToast, IconButton,
//   Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton,
//   useDisclosure, InputGroup, InputLeftElement, Select
// } from '@chakra-ui/react';
// import { MdEdit, MdDelete, MdSearch } from 'react-icons/md';
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import Card from 'components/card/Card';

// export default function CityManagement() {
//   const [countries, setCountries] = useState([]); 
//   const [states, setStates] = useState([]); 
//   const [cities, setCities] = useState([]); 
//   const [searchTerm, setSearchTerm] = useState('');
//   const [loading, setLoading] = useState(false);

//   // Form States
//   const [selectedCountry, setSelectedCountry] = useState('');
//   const [selectedState, setSelectedState] = useState('');
//   const [cityName, setCityName] = useState('');
//   const [editData, setEditData] = useState({ id: '', name: '', stateId: '', countryId: '' });

//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const textColor = useColorModeValue('secondaryGray.900', 'white');
//   const toast = useToast();

//   const baseUrl = (process.env.REACT_APP_BASE_URL || '').replace(/\/?$/, '/');
//   const token = localStorage.getItem('token');

//   const getHeaders = () => ({
//     headers: { Authorization: `Bearer ${token}` }
//   });

//   // 1. Initial Load: Countries and Cities
//   const fetchData = async () => {
//     try {
//       const [countryRes, cityRes] = await Promise.all([
//         axios.get(`${baseUrl}api/location/country`, getHeaders()),
//         axios.get(`${baseUrl}api/location/city`, getHeaders())
//       ]);
//       setCountries(countryRes.data.data || []);
//       setCities(cityRes.data.data || []);
//     } catch (err) {
//       console.error("Fetch Error:", err);
//       toast({ title: 'Error loading data', status: 'error' });
//     }
//   };

//   useEffect(() => { fetchData(); }, []);

//   // 2. Load States based on Country Selection
//   const handleCountryChange = async (countryId) => {
//     setSelectedCountry(countryId);
//     setSelectedState(''); 
//     if (!countryId) {
//       setStates([]);
//       return;
//     }
//     try {
//       // Controller filter query support karta hai: ?countryId=xyz
//       const res = await axios.get(`${baseUrl}api/location/state?countryId=${countryId}`, getHeaders());
//       setStates(res.data.data || []);
//     } catch (err) {
//       setStates([]);
//     }
//   };

//   // 3. Add City
//   const handleAddCity = async () => {
//     if (!cityName || !selectedState || !selectedCountry) {
//       return toast({ title: 'Please select Country, State and enter City name', status: 'warning' });
//     }
//     setLoading(true);
//     try {
//       // Controller expects: { name, stateId, countryId }
//       await axios.post(`${baseUrl}api/location/city`, 
//         { name: cityName, stateId: selectedState, countryId: selectedCountry }, 
//         getHeaders()
//       );
//       toast({ title: 'City Added Successfully!', status: 'success' });
//       setCityName('');
//       fetchData();
//     } catch (err) { 
//       toast({ title: err.response?.data?.message || 'Error adding city', status: 'error' }); 
//     } finally { 
//       setLoading(false); 
//     }
//   };

//   // 4. Update Logic
//   const openEditModal = async (city) => {
//     // Edit ke liye state list load karni padegi
//     try {
//       const res = await axios.get(`${baseUrl}api/location/state?countryId=${city.countryId?._id}`, getHeaders());
//       setStates(res.data.data || []);
//     } catch (err) { console.error(err); }

//     setEditData({ 
//       id: city._id, 
//       name: city.name, 
//       stateId: city.stateId?._id,
//       countryId: city.countryId?._id
//     });
//     onOpen();
//   };

//   const handleUpdate = async () => {
//     try {
//       await axios.put(`${baseUrl}api/location/city/${editData.id}`, 
//         { name: editData.name, stateId: editData.stateId, countryId: editData.countryId },
//         getHeaders()
//       );
//       toast({ title: 'Updated Successfully!', status: 'success' });
//       onClose();
//       fetchData();
//     } catch (err) { 
//       toast({ title: err.response?.data?.message || 'Update failed', status: 'error' }); 
//     }
//   };

//   // 5. Delete Logic
//   const handleDelete = async (id) => {
//     if(window.confirm("Are you sure you want to delete this city?")) {
//       try {
//         await axios.delete(`${baseUrl}api/location/city/${id}`, getHeaders());
//         toast({ title: 'Deleted!', status: 'info' });
//         fetchData();
//       } catch (err) { toast({ title: 'Delete Failed', status: 'error' }); }
//     }
//   };

//   const filteredCities = cities.filter((c) =>
//     c.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     c.stateId?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     c.countryId?.name?.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      
//       {/* ADD SECTION */}
//       <Card mb='20px' p='20px'>
//         <Text color={textColor} fontSize='22px' fontWeight='700' mb='20px'>City Management</Text>
//         <Flex gap='15px' align='flex-end' direction={{ base: 'column', md: 'row' }}>
//           <FormControl>
//             <FormLabel>Country</FormLabel>
//             <Select placeholder='Select Country' value={selectedCountry} onChange={(e) => handleCountryChange(e.target.value)}>
//               {countries.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
//             </Select>
//           </FormControl>
//           <FormControl>
//             <FormLabel>State</FormLabel>
//             <Select placeholder='Select State' value={selectedState} onChange={(e) => setSelectedState(e.target.value)}>
//               {states.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
//             </Select>
//           </FormControl>
//           <FormControl>
//             <FormLabel>City Name</FormLabel>
//             <Input value={cityName} onChange={(e) => setCityName(e.target.value)} placeholder='Ex: Gwalior' />
//           </FormControl>
//           <Button colorScheme='blue' onClick={handleAddCity} isLoading={loading} px='40px' minW='120px'>Add</Button>
//         </Flex>
//       </Card>

//       {/* SEARCH & TABLE SECTION */}
//       <Card p='20px'>
//         <Flex direction={{ base: 'column', md: 'row' }} justify='space-between' align={{ md: 'center' }} mb='20px' gap='10px'>
//           <Text color={textColor} fontSize='18px' fontWeight='700'>All Cities List</Text>
//           <InputGroup maxW={{ md: '300px' }}>
//             <InputLeftElement><MdSearch color='gray.300' /></InputLeftElement>
//             <Input placeholder='Search city, state or country...' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
//           </InputGroup>
//         </Flex>

//         <Box overflowX='auto'>
//           <Table variant='simple'>
//             <Thead bg='gray.50'>
//               <Tr>
//                 <Th>S.No</Th>
//                 <Th>City Name</Th>
//                 <Th>State</Th>
//                 <Th>Country</Th>
//                 <Th>Action</Th>
//               </Tr>
//             </Thead>
//             <Tbody>
//               {filteredCities.map((c, i) => (
//                 <Tr key={c._id}>
//                   <Td>{i + 1}</Td>
//                   <Td fontWeight='600' color='blue.500'>{c.name}</Td>
//                   <Td>{c.stateId?.name || 'N/A'}</Td>
//                   <Td>{c.countryId?.name || 'N/A'}</Td>
//                   <Td>
//                     <IconButton icon={<MdEdit />} colorScheme='green' onClick={() => openEditModal(c)} mr='2' size='sm' />
//                     <IconButton icon={<MdDelete />} colorScheme='red' onClick={() => handleDelete(c._id)} size='sm' />
//                   </Td>
//                 </Tr>
//               ))}
//             </Tbody>
//           </Table>
//         </Box>
//       </Card>

//       {/* UPDATE MODAL */}
//       <Modal isOpen={isOpen} onClose={onClose}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>Update City</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <Flex direction='column' gap='15px'>
//               <FormControl>
//                 <FormLabel>City Name</FormLabel>
//                 <Input value={editData.name} onChange={(e) => setEditData({...editData, name: e.target.value})} />
//               </FormControl>
//               <FormControl>
//                 <FormLabel>Country</FormLabel>
//                 <Select value={editData.countryId} onChange={(e) => {
//                   setEditData({...editData, countryId: e.target.value, stateId: ''});
//                   handleCountryChange(e.target.value); // Load states for new country
//                 }}>
//                   {countries.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
//                 </Select>
//               </FormControl>
//               <FormControl>
//                 <FormLabel>State</FormLabel>
//                 <Select value={editData.stateId} onChange={(e) => setEditData({...editData, stateId: e.target.value})}>
//                   {states.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
//                 </Select>
//               </FormControl>
//             </Flex>
//           </ModalBody>
//           <ModalFooter>
//             <Button colorScheme='blue' mr={3} onClick={handleUpdate}>Save Changes</Button>
//             <Button onClick={onClose}>Cancel</Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>

//     </Box>
//   );
// }

'use client';

import {
  Box, Flex, Table, Tbody, Td, Text, Th, Thead, Tr, useColorModeValue,
  Button, Input, FormControl, FormLabel, useToast, IconButton,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton,
  useDisclosure, InputGroup, InputLeftElement, Select
} from '@chakra-ui/react';
import { MdEdit, MdDelete, MdSearch } from 'react-icons/md';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Card from 'components/card/Card';

export default function CityManagement() {
  const [states, setStates] = useState([]); 
  const [cities, setCities] = useState([]); 
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);

  // Form States
  const [selectedState, setSelectedState] = useState('');
  const [cityName, setCityName] = useState('');
  const [editData, setEditData] = useState({ id: '', name: '', stateId: '' });

  const { isOpen, onOpen, onClose } = useDisclosure();
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const toast = useToast();

  const baseUrl = (process.env.REACT_APP_BASE_URL || '').replace(/\/?$/, '/');
  const token = localStorage.getItem('token');

  const getHeaders = () => ({
    headers: { Authorization: `Bearer ${token}` }
  });

  // 1. Load Active States and All Cities
  const fetchData = async () => {
    try {
      setLoading(true);
      const [stateRes, cityRes] = await Promise.all([
        axios.get(`${baseUrl}api/location/active-list`, getHeaders()),
        axios.get(`${baseUrl}api/location/city`, getHeaders()) // Adjusted to your GET route
      ]);
      setStates(stateRes.data.data || []);
      setCities(cityRes.data.data || []);
    } catch (err) {
      toast({ title: 'Error loading data', status: 'error', isClosable: true });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  // 2. Add City
  const handleAddCity = async () => {
    if (!cityName || !selectedState) {
      return toast({ title: 'Please select a state and enter a city name', status: 'warning' });
    }
    setLoading(true);
    try {
      const selectedStateObj = states.find(s => s._id === selectedState);
      
      await axios.post(`${baseUrl}api/location/city`, 
        { 
          name: cityName, 
          stateId: selectedState, 
          countryId: selectedStateObj?.countryId 
        }, 
        getHeaders()
      );
      
      toast({ title: 'City added successfully!', status: 'success' });
      setCityName('');
      setSelectedState('');
      fetchData();
    } catch (err) { 
      toast({ title: err.response?.data?.message || 'Error adding city', status: 'error' }); 
    } finally { 
      setLoading(false); 
    }
  };

  // 3. Delete Logic
  const handleDelete = async (id) => {
    if(window.confirm("Are you sure you want to delete this city?")) {
      try {
        await axios.delete(`${baseUrl}api/location/city/${id}`, getHeaders());
        toast({ title: 'City deleted successfully', status: 'info' });
        fetchData();
      } catch (err) { 
        toast({ title: 'Delete failed', status: 'error' }); 
      }
    }
  };

  // 4. Edit Modal Open
  const openEditModal = (city) => {
    setEditData({ 
      id: city._id, 
      name: city.name, 
      stateId: city.stateId?._id 
    });
    onOpen();
  };

  // 5. Update Logic
  const handleUpdate = async () => {
    try {
      await axios.put(`${baseUrl}api/location/city/${editData.id}`, 
        { name: editData.name, stateId: editData.stateId },
        getHeaders()
      );
      toast({ title: 'Updated successfully!', status: 'success' });
      onClose();
      fetchData();
    } catch (err) { 
      toast({ title: err.response?.data?.message || 'Update failed', status: 'error' }); 
    }
  };

  const filteredCities = cities.filter((c) =>
    c.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    c.stateId?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      
      {/* ADD SECTION */}
      <Card mb='20px' p='20px'>
        <Text color={textColor} fontSize='22px' fontWeight='700' mb='20px'>City Management</Text>
        <Flex gap='15px' align='flex-end' direction={{ base: 'column', md: 'row' }}>
          <FormControl>
            <FormLabel>Select Active State</FormLabel>
            <Select placeholder='Select State' value={selectedState} onChange={(e) => setSelectedState(e.target.value)}>
              {states.map(s => <option key={s._id} value={s._id}>{s.name.toUpperCase()}</option>)}
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel>City Name</FormLabel>
            <Input value={cityName} onChange={(e) => setCityName(e.target.value)} placeholder='Ex: Indore' />
          </FormControl>
          <Button colorScheme='blue' onClick={handleAddCity} isLoading={loading} px='40px' minW='120px'>Add City</Button>
        </Flex>
      </Card>

      {/* SEARCH & TABLE SECTION */}
      <Card p='20px'>
        <Flex direction={{ base: 'column', md: 'row' }} justify='space-between' align={{ md: 'center' }} mb='20px' gap='10px'>
          <Text color={textColor} fontSize='18px' fontWeight='700'>Registered Cities</Text>
          <InputGroup maxW={{ md: '300px' }}>
            <InputLeftElement><MdSearch color='gray.300' /></InputLeftElement>
            <Input placeholder='Search city or state...' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
          </InputGroup>
        </Flex>

        <Box overflowX='auto'>
          <Table variant='simple'>
            <Thead bg='gray.50'>
              <Tr>
                <Th>S.No</Th>
                <Th>City Name</Th>
                <Th>State Name</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filteredCities.map((c, i) => (
                <Tr key={c._id}>
                  <Td>{i + 1}</Td>
                  <Td fontWeight='600' color='blue.500'>{c.name}</Td>
                  <Td>{c.stateId?.name?.toUpperCase() || 'N/A'}</Td>
                  <Td>
                    <IconButton aria-label="Edit" icon={<MdEdit />} colorScheme='green' onClick={() => openEditModal(c)} mr='2' size='sm' />
                    <IconButton aria-label="Delete" icon={<MdDelete />} colorScheme='red' onClick={() => handleDelete(c._id)} size='sm' />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </Card>

      {/* UPDATE MODAL */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Update City</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction='column' gap='15px'>
              <FormControl>
                <FormLabel>City Name</FormLabel>
                <Input value={editData.name} onChange={(e) => setEditData({...editData, name: e.target.value})} />
              </FormControl>
              <FormControl>
                <FormLabel>State</FormLabel>
                <Select value={editData.stateId} onChange={(e) => setEditData({...editData, stateId: e.target.value})}>
                  {states.map(s => <option key={s._id} value={s._id}>{s.name.toUpperCase()}</option>)}
                </Select>
              </FormControl>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={handleUpdate}>Save Changes</Button>
            <Button onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

    </Box>
  );
}